import { BillingApiClient } from '@fourthwall/services/dist/BillingApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useGetBillingReportMutation = createMutationHook(BillingApiClient.getBillingReport, {
  mutationKey: ['billingRecord'],
})
